import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

import Navbar from "../global-components/navbar-v4";
import PageHeader from "../global-components/page-header";

import CallToActionV1 from "../section-components/call-to-action-v1";
import SponsorV2 from "../section-components/sponsor-v2";
import Footer from "../global-components/footer";


class ResidentialManagement extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div>
        <Navbar />
        <PageHeader headertitle="Residential Management" />

        <div className="ltn__page-details-area ltn__service-details-area mb-105">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="ltn__page-details-inner ltn__service-details-inner">
                  <div className="ltn__blog-grid-img">
                    <img
                      src={publicUrl + "assets/img/service/residential-1.jpeg"}
                      alt="Residential-management"
                    />
                  </div>
                  {/* <p>
                    {" "}
                    We understand that renting out a residential property can be
                    overwhelming....
                  </p> */}

                  <h1>Lettings and Management for Landlords</h1>
                  <p>
                    {" "}
                    <span className="ltn__first-letter">W</span>hether you let a single
                    flat or a house in multiple occupation (HMO), Quoin Management
                    looks after your property and your tenants from the first viewing
                    to the end of the tenancy. We handle the day-to-day work and keep
                    you up to date, so letting your property is as hands-off as you
                    want it to be.
                  </p>
                  <div className="row">
                    <div className="col-lg-6">
                      <img
                        src={
                          publicUrl + "assets/img/service/residential-2.jpeg"
                        }
                        alt="Residential-management"
                      />
                      {/* <label>Image caption here.</label> */}
                    </div>
                    <div className="col-lg-6">
                      <img
                        src={publicUrl + "assets/img/service/residential-3.jpg"}
                        alt="Residential-management"
                      />
                    </div>
                  </div>
                  <h2>Our Residential Management Services</h2>
                  <p>Our full lettings and management service covers:</p>
                  <ul>
                    <li>
                      <strong>Finding tenants:</strong> advertising your property and arranging viewings with suitable applicants. We keep you updated on interest and feedback along the way.
                    </li>
                    <li>
                      <strong>Referencing and Right to Rent:</strong> checking applicants' references and affordability, and carrying out the Right to Rent checks the law requires. We keep a record of every check in case it is ever needed.
                    </li>
                    <li>
                      <strong>Tenancy agreements:</strong> preparing a clear tenancy agreement that reflects the law as it stands. Under the Renters' Rights Act 2025, most new tenancies in England are periodic, and we make sure your paperwork is set up correctly.
                    </li>
                    <li>
                      <strong>Deposit protection:</strong> registering the tenant's deposit with mydeposits and giving the tenant the information the law requires. At the end of the tenancy, we manage the return of the deposit, including any agreed deductions.
                    </li>
                    <li>
                      <strong>Rent collection and statements:</strong> collecting the rent each month and paying it to you, less any agreed costs. You receive a clear monthly statement showing what was collected and what was spent on the property.
                    </li>
                    <li>
                      <strong>Rent arrears:</strong> following up promptly if rent is late and agreeing a way forward with the tenant. If arrears continue, we serve the correct notice and work with a solicitor where needed.
                    </li>
                    <li>
                      <strong>Safety certificates:</strong> arranging gas safety checks, electrical safety reports (EICRs) and Energy Performance Certificates (EPCs), and making sure smoke and carbon monoxide alarms are fitted and working. We track every renewal date so nothing expires unnoticed.
                    </li>
                    <li>
                      <strong>Repairs and maintenance:</strong> arranging repairs through trusted local contractors when tenants report a problem. We keep you informed of the cost and progress of the work.
                    </li>
                    <li>
                      <strong>Property inspections:</strong> visiting the property quarterly to check its condition and that the tenancy is running smoothly. We let you know about anything that needs attention.
                    </li>
                    <li>
                      <strong>HMO management and licensing:</strong> managing houses in multiple occupation, including applying for and renewing HMO licences with the local council. We make sure the property meets the extra safety and management standards that apply to HMOs.
                    </li>
                    <li>
                      <strong>Inventories, check-in and check-out:</strong> preparing a detailed inventory before the tenant moves in and checking the property against it when they leave. This gives both sides a clear record if there is ever a dispute over the deposit.
                    </li>
                    <li>
                      <strong>End-of-tenancy cleaning and refurbishment:</strong> arranging professional cleaning between tenancies, and refurbishment where the property needs it. This helps you re-let the property at the right rent.
                    </li>
                    <li>
                      <strong>Keeping you up to date:</strong> letting rules are changing under the Renters' Rights Act 2025. We explain what the changes mean for you and make sure your property and paperwork stay compliant.
                    </li>
                  </ul>
                  <p>
                    Whether you have one property or a growing portfolio, we would be
                    happy to talk about how we can look after it.{" "}
                    <Link to="/contact">Get in touch</Link>.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <aside className="sidebar-area ltn__right-sidebar">
                  {/* Menu Widget */}
                  <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                    <ul className="go-top">
                      <li>
                        <Link to="/property-management">
                          Property Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li className="active">
                        <Link to="/residential-management">
                          Residential Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/commercial-management">
                          Commercial Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/compliance-management">
                          Compliance Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/legal">
                          Legal{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/emergency-response">
                          Emergency Response{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/refurbishment">
                          Refurbishment{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/block-management">
                          Block Management{" "}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* Newsletter Widget */}
                  <div className="widget ltn__search-widget ltn__newsletter-widget">
                    <h6 className="ltn__widget-sub-title">Subscribe</h6>
                    <h4 className="ltn__widget-title">Get Newsletter</h4>
                    <form action="#">
                      <input type="text" name="search" placeholder="Search" />
                      <button type="submit">
                        <i className="fas fa-search" />
                      </button>
                    </form>
                    <div className="ltn__newsletter-bg-icon">
                      <i className="fas fa-envelope-open-text" />
                    </div>
                  </div>
                  {/* Banner Widget */}
                  <div className="widget ltn__banner-widget go-top">
                    {/* <Link to="/shop">
                      <img
                        src={publicUrl + "assets/img/banner/banner-1.jpg"}
                        alt="Banner Image"
                      />
                    </Link> */}
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
        <SponsorV2 />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default ResidentialManagement;
